import { Typography } from '@material-ui/core'
import { darkGrey, isLastStep } from '../utils'
import ParentWrapper from './ParentWrapper'
import StatusProgressV2 from './StatusProgressV2'

const TicketDescription = ({ record }) => {
  if (isLastStep(record) === true) return null

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <Typography
        variant="h5"
        style={{
          color: darkGrey,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          cursor: 'pointer',
        }}
        gutterBottom="true"
      >
        <p style={{ margin: 0 }}>
          {record?.process_name?.replaceAll(/s+\b/g, '')}
        </p>
      </Typography>

      <Typography variant="subtitle2" style={{ color: darkGrey }}>
        Ticket #{record.reference}
        <br />
        {record.copro_name}
        <br />
        <StatusProgressV2 ticket={record} />
        {record.parent_ticket === null ||
        record.parent_ticket === undefined ? null : (
          <ParentWrapper record={record} />
        )}
      </Typography>
    </div>
  )
}
export default TicketDescription
